import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ContainersDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ContainersManagementScreen from "../../../screens/Containers/ContainersManagementScreen";
import ItemsManagementScreen from "../../../screens/Containers/ItemsManagementScreen";
import ManageContainers from "../../../screens/Containers/ManageContainers";
import { useTranslation } from "../../../utils/useTranslation";

import { useAppTheme } from "../../../hooks/useAppTheme";

const Drawer = createDrawerNavigator();

export default function ContainersDrawerNavigator() {
  const { colors } = useAppTheme();
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
        headerTintColor: colors.text,
        headerStyle: {
          backgroundColor: colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: colors.border,
        },
        headerTitleStyle: {
          color: colors.text,
        },
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={drawerItemsMain} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: t("containersManagement"),
          title: t("containersStatus"),
        }}
        name="ContainersManagement"
        component={ContainersManagementScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("addContainer"),
          title: t("manageContainer"),
        }}
        name="ManageContainers"
        component={ManageContainers}
        initialParams={{ mode: "create", container: {} }}
      />
      <Drawer.Screen
        options={{ drawerLabel: t("itemsManagement"), title: t("itemsManagement") }}
        name="ItemsManagement"
        component={ItemsManagementScreen}
      />
    </Drawer.Navigator>
  );
}
